const routes = {
  about: "/",
  skill: "/skills",
  games: "/games",
  projects: "/projects",
  pinterest: "/gallery",
  projectDetails: "/projects/:projectName",
  hentai: "/fav-hentai-list",
  blog: "/blog",
  blogPost: "/blog/:id",
  anime: "/anime",
  nuoitoi: "/nuoitoi",
  notfound: "/*",
};

export default routes;
